// extracted by mini-css-extract-plugin
module.exports = {"loading":"ProductTile_loading__3xPvx","ellipsis":"ProductTile_ellipsis__2K_Ko"};